import { useTranslation } from 'react-i18next';

import { RequirementDto } from '../../queries';
import { PasswordRequirementItem, RequirementsTitleStyled } from './components';
import { isRequirementFulfilled } from './utils';

export const PasswordRequirements = ({
  requirements,
  loadingRequirements,
  password,
}: {
  requirements?: RequirementDto[];
  loadingRequirements: boolean;
  password: string;
}) => {
  const { t } = useTranslation('pages.changePassword');
  if (loadingRequirements || !requirements || requirements.length === 0) {
    return <div />;
  }

  return (
    <div className="password-requirements">
      <RequirementsTitleStyled
        data-testid="requirements-title"
        className="headline-3"
      >
        {t('mustHave')}
      </RequirementsTitleStyled>
      {requirements.map((requirement: RequirementDto) => (
        <PasswordRequirementItem
          text={requirement.description}
          valid={isRequirementFulfilled(password, requirement)}
          key={requirement.lookup_code}
        />
      ))}
    </div>
  );
};
